import { useCallback } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'

type UseInfiniteScrollProps = {
  fetchNextPage: () => void
  hasNextPage: boolean
  isFetchingNextPage: boolean
  loadMoreDisabled?: boolean
}

export const useInfiniteScrollFetch = ({
  fetchNextPage,
  hasNextPage,
  isFetchingNextPage,
  loadMoreDisabled,
}: UseInfiniteScrollProps) => {
  // Function to fetch more data when scrolling
  const loadMore = useCallback(() => {
    if (!hasNextPage || isFetchingNextPage || loadMoreDisabled) return

    fetchNextPage()
  }, [isFetchingNextPage, fetchNextPage, hasNextPage])

  // Hook for infinite scrolling
  const [infiniteRef, { rootRef }] = useInfiniteScroll({
    loading: !!isFetchingNextPage,
    hasNextPage,
    onLoadMore: loadMore,
  })

  return {
    infiniteRef,
    rootRef,
  }
}
